import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const LegalPage = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white">
            <div className="max-w-4xl mx-auto px-4 py-12">
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-8">
                    <p className="text-sm text-gray-600 italic">{t("legal.bindingVersion")}</p>
                </div>

                <h1 className="text-4xl font-bold mb-8 text-gray-900">Impressum</h1>

                <div className="space-y-6 text-gray-700">
                    <div>
                        <h2 className="text-xl font-semibold mb-2 text-gray-900">
                            Angaben gemäß § 5 TMG
                        </h2>
                        <p className="leading-relaxed">
                            AusspracheTrainer g.e.V.
                            <br />
                            c/o Dr. Oliver Busch
                            <br />
                            Mühlgasse 8
                            <br />
                            60486 Frankfurt am Main
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold mb-2 text-gray-900">Kontakt</h2>
                        <p className="leading-relaxed">
                            E-Mail:{" "}
                            <a
                                href="mailto:kontakt@aussprachetrainer.org"
                                className="text-blue-600 hover:underline"
                            >
                                kontakt@aussprachetrainer.org
                            </a>
                        </p>
                        <p className="leading-relaxed mt-2">Ansprechpartner: Daniel Busch</p>
                    </div>

                    <div>
                        <h2 className="text-xl font-semibold mb-2 text-gray-900">
                            Registereintrag
                        </h2>
                        <p className="leading-relaxed">
                            Registergericht: Amtsgericht Frankfurt am Main
                            <br />
                            Registernummer: VR 17083
                        </p>
                    </div>
                </div>

                {/* Link to About Page */}
                <div className="mt-12 pt-8 border-t border-gray-200">
                    <Link
                        to="/about"
                        className="inline-flex items-center text-primary hover:text-purple-600 font-semibold transition-colors duration-300"
                    >
                        {t("aboutUs")} →
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default LegalPage;
